export const SUCCESS_DIVIDER_LIST = "SUCCESS_DIVIDER_LIST";
export const LOADING_DIVIDER_LIST = "LOADING_DIVIDER_LIST";
export const SUCCESS_BLANK_SLIDE_LIST = "SUCCESS_BLANK_SLIDE_LIST";
export const LOADING_BLANK_SLIDE_LIST = "LOADING_BLANK_SLIDE_LIST";
